export function downloadFile(data, filename, type) {
    // It is necessary to create a new blob object with mime-type explicitly set
    // otherwise only Chrome works like it should
    // Legacy hack. Added type parameter It was harcoded to 'application/vnd'
    if (type === undefined) {
      type = 'application/vnd';
    }
    let newBlob = new Blob([data.data], { type: type })
    
    // IE doesn't allow using a blob object directly as link href
    // instead it is necessary to use msSaveOrOpenBlob
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(newBlob)
      return
    }

    // For other browsers:
    // Create a link pointing to the ObjectURL containing the blob.
    const ob = window.URL.createObjectURL(newBlob)
    let link = document.createElement('a')
    link.href = ob
    link.download = filename //+ '.docx'
    link.click()
    setTimeout(function () {
      // For Firefox it is necessary to delay revoking the ObjectURL
      window.URL.revokeObjectURL(ob)
    }, 100)
}
